import TabsButtons from '../components/TabsButtons';

const TabsButtonPage = () => {
  return (
    <div>
      <TabsButtons />
    </div>
  );
};

export default TabsButtonPage;
